import { Order } from "./order.type";

/**
 * The API-Platform JSON-LD response represents item collections as an object
 * keyed by item id (e.g. `{ "<uuid>": {...item...} }`) rather than an indexed
 * array. Mercure events mirror that shape. Most of our UI iterates these
 * collections as arrays, so we normalize once at the wire boundary.
 */
function toArray<T>(value: unknown): T[] {
  if (Array.isArray(value)) return value as T[];
  if (value && typeof value === "object") return Object.values(value) as T[];
  return [];
}

export function normalizeOrder<T extends Partial<Order> | undefined | null>(
  order: T,
): T {
  if (!order) return order;
  const next = order as Order;
  if (next.orderItems !== undefined) {
    next.orderItems = toArray(next.orderItems);
  }
  if (next.menuComboOrderItems !== undefined) {
    next.menuComboOrderItems = toArray(next.menuComboOrderItems);
  }
  if (next.menuFormulaOrderItems !== undefined) {
    next.menuFormulaOrderItems = toArray(next.menuFormulaOrderItems);
  }
  return order;
}
